<app-import-nav />

@if (!loading) {
  <div>
    @if (captureInvoiceLineItemImports.length > 0) {
      <section class="mt-3">
        <div class="col-12">
          <app-pagination-header [paging]="paging" [label]="'imports'" (pageSizeChange)="onPageSizeChange($event)" />
        </div>
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>STATUS</th>
              <th class="text-nowrap text-end">FILES</th>
              <th class="text-nowrap text-end">DATE IMPORTED</th>
              <th class="text-end">TOTAL ROWS</th>
              <th class="text-end">PROCESSED</th>
              <th class="text-end">SKIPPED</th>
              <th class="text-end">IMPORTED</th>
            </tr>
          </thead>
          <tbody>
            @for (import of captureInvoiceLineItemImports; track import) {
              <tr>
                <td [attr.title]="import.status === 'failed' ? import.failureMessage : null">
                  {{ import.status | titlecase }}
                  <fa-icon [hidden]="!import.active" [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" />
                  <div [hidden]="!import.active">
                    <button class="btn btn-sm btn-danger" (click)="onCancelClick($event, import)">CANCEL</button>
                  </div>
                </td>
                <td class="text-end">
                  <small>
                    <div ngbDropdown class="d-inline-block">
                      <button id="downloadDropdown" class="btn btn-sm btn-secondary" ngbDropdownToggle>Download</button>
                      <div ngbDropdownMenu aria-labelledby="downloadDropdown">
                        <a [hidden]="!import.hasSkippedFile"
                          class="dropdown-item btn-sm"
                          href="#downloadSkipped"
                          (click)="onDownloadSkippedClick($event, import)">
                          Skipped Records File
                        </a>
                        <a class="dropdown-item btn-sm"
                          href="#downloadOriginal"
                          (click)="onDownloadOriginalClick($event, import)">
                          Uploaded File
                        </a >
                      </div>
                    </div>
                  </small>
                </td>
                <td class="text-end">
                  {{ import.createdAt | date: 'M/d/yyyy h:mm a' }}
                  <div>
                    <small>{{ import.username }}</small>
                  </div>
                </td>
                <td class="text-end">{{ import.totalRows | number: '' }}</td>
                <td class="text-end">{{ import.processed | number: '' }}</td>
                <td class="text-end">{{ import.skipped | number: '' }}</td>
                <td class="text-end">{{ import.imported | number: '' }}</td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </section>
    } @else {
      <section class="mt-3"><p>There are no imports.</p></section>
    }
  </div>
} @else {
  <section class="mt-3"><mat-spinner diameter="30" /></section>
}
